export const SEARCH_RESULT_LIMIT = 20000;
export const SEARCH_RESULTS_PER_PAGE = 100;

const formatNumber = (value) => Number(value || 0).toLocaleString();

export const getSearchPageLimit = (
  totalRecords,
  perPage = SEARCH_RESULTS_PER_PAGE
) => {
  const safePerPage = Math.max(Number(perPage) || SEARCH_RESULTS_PER_PAGE, 1);
  const visibleTotal = Math.min(Number(totalRecords) || 0, SEARCH_RESULT_LIMIT);

  return Math.max(Math.ceil(visibleTotal / safePerPage), 1);
};

export const normalizeSearchPage = (
  page,
  totalRecords,
  perPage = SEARCH_RESULTS_PER_PAGE
) => {
  const safePage = Math.max(Number(page) || 1, 1);

  return Math.min(safePage, getSearchPageLimit(totalRecords, perPage));
};

export const getSearchResultSummary = ({
  page,
  totalRecords,
  visibleCount,
  perPage = SEARCH_RESULTS_PER_PAGE,
}) => {
  const visibleTotal = Math.min(Number(totalRecords) || 0, SEARCH_RESULT_LIMIT);
  const realTotal = Number(totalRecords) || 0;

  if (realTotal <= 0) {
    return "0 property.";
  }

  const safePage = normalizeSearchPage(page, realTotal, perPage);
  const countOnPage = Math.max(Number(visibleCount) || 0, 0);
  const start = Math.min((safePage - 1) * perPage + 1, visibleTotal);
  const end = Math.min((safePage - 1) * perPage + countOnPage, visibleTotal);

  return `Showing ${formatNumber(start)} to ${formatNumber(end)} of ${formatNumber(realTotal)} ${
    realTotal > 1 ? "properties" : "property"
  }`;
};
